import { render, staticRenderFns } from "./ResultsTableContainer.vue?vue&type=template&id=bff99b0a"
import script from "./ResultsTableContainer.vue?vue&type=script&lang=js"
export * from "./ResultsTableContainer.vue?vue&type=script&lang=js"
import style0 from "./ResultsTableContainer.vue?vue&type=style&index=0&id=bff99b0a&prod&lang=scss"
import style1 from "./ResultsTableContainer.vue?vue&type=style&index=1&id=bff99b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports